export default "__VITE_ASSET__DIm0ymy1__"